/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import React from 'react';
import { useDispatch } from 'react-redux';
import { ConfirmationModal } from '../../common/Modals/ConfirmationModal/ConfirmationModal';
import { updateExitModalStatus } from '../../../actions/signingRoomActions';
import { useRootSelector } from '../../../hooks/useRootSelector';

export namespace ExitSessionConfirmationModal {
  export interface Props {}
}

export const ExitSessionConfirmationModal: React.FC<ExitSessionConfirmationModal.Props> = () => {
  const dispatch = useDispatch();
  const { isExitModalOpen } = useRootSelector(state => state.signingRoom);
  const roomId = window.location.pathname.split('/')[2];
  return (
    <ConfirmationModal
      isOpen={isExitModalOpen}
      handleClose={() => {
        updateExitModalStatus(false)(dispatch);
      }}
      handleConfirm={() => {
        window.location.assign(`/rooms/${roomId}/exit`);
        updateExitModalStatus(false);
      }}
      contentLabel="Exit online notarization"
      heading="Are you sure you want to exit?"
      description={'If you exit now, this online notarization may have to be rescheduled.'}
      confirmButtonText="Yes"
      closeButtonText="Cancel"
      data-it="ExitSessionConfirmationModal-Participant"
    />
  );
};
